import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _excluded = ["element", "primitive", "children"];

var _templateObject, _templateObject2;

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { calculateRem } from '@uie/javascript-style-helpers';
import { breakpoints, colors } from '@vds-core/theme';
import { TypographyConfig, TitleConfig } from '@vds-core/typography';
var coreTypescale = TypographyConfig.getTypescale();
var propTypes = {
  /**
   * @deprecated primitive
   */
  element: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),

  /**
   * The primitive prop will alter a string provided to the header to be one of h1, h2, h3, h4, h5, h6
   */
  primitive: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),

  /**
   * Title area Text or React Component that will be shown in the Modal Header.
   * @note If you provide a React Component for this Property, you are responsible for providing all the appropriate formatting as well.
   */
  children: PropTypes.node,

  /**
   * @ignore
   * Pass a Title typography configuration object
   */
  titleConfig: PropTypes.object,

  /**
   * @ignore
   * Padding styles for the ModalBody
   */
  padding: PropTypes.string,

  /**
   * @ignore
   * Function to calculate the typography to be used
   */
  calcTypography: PropTypes.func,

  /**
   * @ignore
   * Pass a supported Typescale
   */
  typescale: PropTypes.oneOf(['VDS', 'MVP', 'Marketing']),

  /**
   * @ignore
   * Add right padding to account for close button
   */
  rightPadding: PropTypes.bool,

  /**
   * @ignore
   * Inverted style
   */
  inverted: PropTypes.bool
};

function _calcTypography(titleConfig, viewport, typescale) {
  var size = viewport === 'mobile' ? 'small' : 'medium';
  return titleConfig.getStyles(typescale, 'desktop', size);
}

var defaultProps = {
  children: null,
  element: 'h2',
  primitive: 'h2',
  titleConfig: TitleConfig,
  typescale: coreTypescale,
  padding: calculateRem(16, 16, 0, 16),
  calcTypography: _calcTypography,
  rightPadding: false
}; //VDS 1.0 padding-right = 48px hit area + 8px offset - 16px padding right on dialog

var StyledHeader = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledHeader",
  componentId: "sc-1fp2hi0-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  &:hover,\n  &:active,\n  &:visited {\n    outline: none;\n  }\n"])), function (_ref) {
  var rightPadding = _ref.rightPadding;
  return rightPadding && "\n  padding-right: 40px;\n  ";
});
/**
 * @ignore
 */

var StyledHeaderText = /*#__PURE__*/styled(function (_ref2) {
  var _ref2$element = _ref2.element,
      element = _ref2$element === void 0 ? 'h2' : _ref2$element,
      _ref2$primitive = _ref2.primitive,
      primitive = _ref2$primitive === void 0 ? 'h2' : _ref2$primitive,
      children = _ref2.children,
      props = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/React.createElement(primitive, props, children);
}).attrs({}).withConfig({
  displayName: "StyledHeaderText",
  componentId: "sc-1fp2hi0-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  font-family: ", ";\n  padding: ", ";\n  margin: 0;\n  flex: 1;\n\n  @media (min-width: ", ") {\n    font-size: ", ";\n    line-height: ", ";\n    font-family: ", ";\n  }\n"])), function (_ref3) {
  var inverted = _ref3.inverted;
  return inverted ? colors.white : colors.black;
}, function (_ref4) {
  var mobiletype = _ref4.mobiletype;
  return calculateRem(mobiletype.fontSize);
}, function (_ref5) {
  var mobiletype = _ref5.mobiletype;
  return calculateRem(mobiletype.lineHeight);
}, function (_ref6) {
  var mobiletype = _ref6.mobiletype;
  return mobiletype.fontFamily;
}, function (_ref7) {
  var padding = _ref7.padding;
  return padding;
}, breakpoints.md, function (_ref8) {
  var desktoptype = _ref8.desktoptype;
  return calculateRem(desktoptype.fontSize);
}, function (_ref9) {
  var desktoptype = _ref9.desktoptype;
  return calculateRem(desktoptype.lineHeight);
}, function (_ref10) {
  var desktoptype = _ref10.desktoptype;
  return desktoptype.fontFamily;
});

var ModalTitle = function ModalTitle(props) {
  var children = props.children,
      element = props.element,
      primitive = props.primitive,
      titleConfig = props.titleConfig,
      paddingProp = props.padding,
      typescale = props.typescale,
      calcTypography = props.calcTypography,
      rightPadding = props.rightPadding,
      inverted = props.inverted;
  var desktopType = calcTypography(titleConfig, 'desktop', typescale);
  var mobileType = calcTypography(titleConfig, 'mobile', typescale);
  return /*#__PURE__*/React.createElement(StyledHeader, {
    rightPadding: rightPadding,
    "data-testid": "modal-header"
  }, /*#__PURE__*/React.createElement(StyledHeaderText, {
    desktoptype: desktopType,
    mobiletype: mobileType,
    element: element,
    padding: paddingProp,
    primitive: primitive,
    inverted: inverted
  }, children));
};

ModalTitle.propTypes = propTypes;
ModalTitle.defaultProps = defaultProps;
export default ModalTitle;